import React, { useEffect } from 'react';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { initiatePwReset } from '../../services/apiService';
import { emailValidate } from '../../services/formValidationService';
import FormInput from '../general-components/FormInput';
import Button, { ButtonType } from '../general-components/Button';
import SignupLayout from './../ui-components/SignupLayout';
import styles from './InitiatePasswordReset.module.css';

const InitiatePasswordReset = () => {
    const { t } = useTranslation();
    const [shownComponent, setShownComponent] = useState('reset');
    const [resetEmail, setResetEmail] = useState('');

    const [error, setError] = useState('');

    const submit = async () => {
        const ev = emailValidate(resetEmail);
        if (ev.valid) {
            const res = await initiatePwReset(resetEmail);
            if (res.succeded) setShownComponent('confirm');
            else setError(res.message);
        } else {
            setError(ev.message);
        }
    };

    useEffect(() => {
        const listener = (event: any) => {
            if (event.code === 'Enter' || event.code === 'NumpadEnter') {
                event.preventDefault();
                submit();
            }
        };
        document.addEventListener('keydown', listener);
        return () => {
            document.removeEventListener('keydown', listener);
        };
    }, [resetEmail]);

    return (
        <SignupLayout>
            {shownComponent === 'confirm' && (
                <div className={styles.wrapper}>
                    <div className={styles.info}>
                        <h3>
                            {t('passwordReset.initiateReset.confirm.title')}
                        </h3>
                        <p>
                            {t('passwordReset.initiateReset.confirm.message')}
                        </p>
                    </div>
                    <form className={styles.form}>
                        <Button
                            className={styles.button}
                            type={ButtonType.primary}
                            onClick={() => {
                                window.location.href = '/login';
                            }}
                        >
                            {t(
                                'passwordReset.initiateReset.confirm.buttons.returnToLogin'
                            )}
                        </Button>
                    </form>
                </div>
            )}
            {shownComponent === 'reset' && (
                <div className={styles.wrapper}>
                    <div className={styles.info}>
                        <h3>{t('passwordReset.initiateReset.reset.title')}</h3>
                        <p>{t('passwordReset.initiateReset.reset.message')}</p>
                    </div>
                    <form className={styles.form}>
                        <FormInput
                            className={styles.email}
                            label={t(
                                'passwordReset.initiateReset.reset.form.email'
                            )}
                            name="email"
                            placeholder={t(
                                'passwordReset.initiateReset.reset.form.placeholder'
                            )}
                            onChange={({ target }) => {
                                setResetEmail(
                                    (target as HTMLInputElement).value
                                );
                            }}
                            type="email"
                            errorMsg={error}
                        />
                        <Button
                            className={styles.button}
                            type={ButtonType.submit}
                            onClick={submit}
                        >
                            {t(
                                'passwordReset.initiateReset.reset.form.buttons.send'
                            )}
                        </Button>
                    </form>
                </div>
            )}
        </SignupLayout>
    );
};

export default InitiatePasswordReset;
